import { render, staticRenderFns } from "./renewal-popup.vue?vue&type=template&id=a831b7ac&scoped=true&lang=pug&"
import script from "./renewal-popup.vue?vue&type=script&lang=js&"
export * from "./renewal-popup.vue?vue&type=script&lang=js&"
import style0 from "./renewal-popup.vue?vue&type=style&index=0&id=a831b7ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a831b7ac",
  null
  
)

export default component.exports